module.exports = __webpack_public_path__ + "img/do_need_insurance.1fd47951.webp";